import axios from 'axios';

export const getCollectionCardThumbnail = (favouriteProperties, collectionType, collectionPropertyIds = []) => {
  let linkUrlImage = '';

  if(collectionType === 'default') {
    if (favouriteProperties?.length > 0) {
      for(let i = 0; i < favouriteProperties.length; i++) {
        linkUrlImage = favouriteProperties[i].property?.links?.filter(link => link.rel === 'mainImage');
        if (linkUrlImage?.length > 0) {
          return linkUrlImage[0].href;
        }
      }
    }
  } else {
    for(let i = 0; collectionPropertyIds?.length - 1 >= i; i++) {
      if (favouriteProperties?.length > 0) {
        const favourite = favouriteProperties.filter(fav => fav.propertyId === collectionPropertyIds[i]);
        if(favourite?.length > 0) {
          linkUrlImage = favourite[0].property?.links?.filter(link => link.rel === 'mainImage');
          if (linkUrlImage?.length > 0) {
            return linkUrlImage[0].href;
          }
        }
      }
    }
  }
  return '/assets/images/icon_happy.svg';
};

const property_url = process.env.ODIN_BASE_URL + '/odin/api/properties/';
const listing_url = process.env.ODIN_BASE_URL + '/odin/api/listings/';
export const getPropertyImages = async (property, shouldGetSingleImage) => {
  try {
    const maxImageCount = shouldGetSingleImage ? 1 : 24;
    let url = `${(property.category.toLowerCase() === 'property') ? property_url : listing_url}${property.id}/images?maxImageCount=${maxImageCount}`;
    const image_resp = await axios.get(url);
    if (image_resp.status === 200) {
      return image_resp.data.content;
    }
    return [];
  } catch (e) {
    return [];
  }
};
